/**
 * Where to go back after a gate (data policy...). Only a path inside the app,
 * in the current language, is followed; anything else falls back to home so a
 * crafted ?next= link can't send someone to another site.
 */
export function safeReturnPath(next: string | null | undefined, lang: string): string {
  const home = `/${lang}`;
  if (!next) return home;
  if (!next.startsWith(`${home}/`) || next.startsWith("//") || next.includes("\\")) return home;
  return next;
}
